import { useQuery } from 'react-query';
import useAuthenticatedClients from './useAuthenticatedClients';
import { queryKeys } from '../constants';

export default function useProjects() {
  const { getProjectsClient } = useAuthenticatedClients();
  const { PROJECTS_QUERY_KEY } = queryKeys;

  return useQuery(PROJECTS_QUERY_KEY, () => {
    return getProjectsClient().then(client => client.getProjects());
  });
}
